<script setup lang="ts">
import type { VSheet } from 'vuetify/components';
import { computed } from 'vue';

type PropsType = {
    elevation?: string | number;
    color?: string;
    rounded?: boolean | string;
    height?: string | number;
    width?: string | number;
    maxHeight?: string | number;
    maxWidth?: string | number;
    minHeight?: string | number;
    minWidth?: string | number;
    position?: VSheet['$props']['position'];
    tag?: string;
    theme?: string;
    classes?: string;
};

const props = withDefaults(defineProps<PropsType>(), {
    elevation: undefined,
    color: undefined,
    rounded: false,
    height: undefined,
    width: undefined,
    maxHeight: undefined,
    maxWidth: undefined,
    minHeight: undefined,
    minWidth: undefined,
    position: 'static',
    tag: 'div',
    theme: undefined,
    classes: '',
});

const getClasses = computed(() => {
    return 'b-sheet ' + props.classes;
});

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VSheet
        :elevation="elevation"
        :color="color"
        :rounded="rounded"
        :height="height"
        :width="width"
        :max-height="maxHeight"
        :max-width="maxWidth"
        :min-height="minHeight"
        :min-width="minWidth"
        :position="position"
        :tag="tag"
        :theme="theme"
        v-bind="$attrs"
        :class="getClasses"
    >
        <slot />
    </VSheet>
</template>
